export default {
  brandColor1: '#252423',
  complimentaryColor1: '#fff',
  brandColor2: '#EBC15B',
  complimentaryColor2: '#fff',
};
